module.exports = __webpack_public_path__ + "images/free-trial/light.a009cb5a5ddc30570b36.svg";